export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "appliedDiscounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applied discounts"])}
      },
      "de": {
        "appliedDiscounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angewandte Rabatte"])}
      }
    }
  })
}